//import union from 'lodash/union'
import {
  TLIST_REQUEST,
  TLIST_SUCCESS,
  TLIST_FAILURE,
  VTLIST_REQUEST,
  VTLIST_SUCCESS,
  VTLIST_FAILURE,
  TLIST_SEND_REQUEST, 
  TLIST_SEND_SUCCESS, 
  TLIST_SEND_FAILURE,
  TLIST_REMOVE_REQUEST, 
  TLIST_REMOVE_SUCCESS, 
  TLIST_REMOVE_FAILURE,
  VTLIST_ADD_REQUEST, 
  VTLIST_ADD_SUCCESS, 
  VTLIST_ADD_FAILURE,
  VTLIST_DELETE_REQUEST, 
  VTLIST_DELETE_SUCCESS, 
  VTLIST_DELETE_FAILURE,
  VTLIST_UPDATE_REQUEST, 
  VTLIST_UPDATE_SUCCESS, 
  VTLIST_UPDATE_FAILURE,
  NHLIST_REQUEST, 
  NHLIST_SUCCESS, 
  NHLIST_FAILURE,
  TASKS_REQUEST, 
  TASKS_SUCCESS, 
  TASKS_FAILURE

} from 'actions/zendesk';

export default (state = {
  isTLFetching: false,
  isVTFetching: false,
  error: undefined,
  tickets: [],
  violationTypes: [],
  isTLSending: false,
  isTLSent: false,
  isTLRemoving: false,
  isTLRemoved: false,
  isVTAdding: false,
  isVTAdded: false,
  isVTDeleting: false,
  isVTDeleted: false,
  isVTUpdating: false,
  isVTUpdated: false,
  isNHFetching: false,
  notificationList: [],
  isTasksFetching: false,
  tasks: [],

}, action) => {
  switch (action.type) {
    case TLIST_REQUEST:
      return {
        ...state,
        isTLFetching: true
      }
    case TLIST_SUCCESS:
      return {
        ...state,
        isTLFetching: false,
        tickets: action.response,
        error: undefined
      }
    case TLIST_FAILURE:
      return {
        ...state,
        isTLFetching: false,
        error: action.error
      }
    case TLIST_SEND_REQUEST:
      return {
        ...state,
        isTLSending: true,
        isTLSent: false,
      }
    case TLIST_SEND_SUCCESS:
      return {
        ...state,
        isTLSending: false,
        isTLSent: true,
        error: undefined
      }
    case TLIST_SEND_FAILURE:
      return {
        ...state,
        isTLSending: false,
        isTLSent: false,
        error: action.error
      }  
    case TLIST_REMOVE_REQUEST:
      return {
        ...state,
        isTLRemoving: true,
        isTLRemoved: false,
      }
    case TLIST_REMOVE_SUCCESS:
      return {
        ...state,
        isTLRemoving: false,
        isTLRemoved: true,
        error: undefined
      }
    case TLIST_REMOVE_FAILURE:
      return {
        ...state,
        isTLRemoving: false,
        isTLRemoved: false,
        error: action.error
      }    
    case VTLIST_REQUEST:
      return {
        ...state,
        isVTFetching: true
      }
    case VTLIST_SUCCESS:
      return {
        ...state,
        isVTFetching: false,
        violationTypes: action.response,
        error: undefined
      }
    case VTLIST_FAILURE:
      return {
        ...state,
        isVTFetching: false,
        error: action.error
      }
    case VTLIST_ADD_REQUEST:
      return {
        ...state,
        isVTAdding: true,
        isVTAdded: false,
      }
    case VTLIST_ADD_SUCCESS:
      return {
        ...state,
        isVTAdding: false,
        isVTAdded: true,
        error: undefined
      }
    case VTLIST_ADD_FAILURE:
      return {
        ...state,
        isVTAdding: false,
        isVTAdded: false,
        error: action.error
      }
    case VTLIST_DELETE_REQUEST:
      return {
        ...state,
        isVTDeleting: true,
        isVTDeleted: false,
      }
    case VTLIST_DELETE_SUCCESS:
      return {
        ...state,
        isVTDeleting: false,
        isVTDeleted: true,
        error: undefined
      }
    case VTLIST_DELETE_FAILURE:
      return {
        ...state,
        isVTDeleting: false,
        isVTDeleted: false,
        error: action.error
      }
    case VTLIST_UPDATE_REQUEST:
      return {
        ...state,
        isVTUpdating: true,
        isVTUpdated: false,
      }
    case VTLIST_UPDATE_SUCCESS:
      return {
        ...state,
        isVTUpdating: false,
        isVTUpdated: true,
        error: undefined
      }
    case VTLIST_UPDATE_FAILURE:
      return {
        ...state,
        isVTUpdating: false,
        isVTUpdated: false,
        error: action.error
      }
    case NHLIST_REQUEST:
        return {
          ...state,
          isNHFetching: true
        }
    case NHLIST_SUCCESS:
      return {
        ...state,
        isNHFetching: false,
        notificationList: action.response,
        error: undefined
      }
    case NHLIST_FAILURE:
      return {
        ...state,
        isNHFetching: false,
        error: action.error
      }
    case TASKS_REQUEST:
      return {
        ...state,
        isTasksFetching: true
      }
    case TASKS_SUCCESS:
      return {
        ...state,
        isTasksFetching: false,
        tasks: action.response,
        error: undefined
      }
    case TASKS_FAILURE:
      return {
        ...state,
        isTasksFetching: false,
        error: action.error
      }

    default:
      return state;
  }
}
